import { render, staticRenderFns } from "./ReportOccurrenceQuality.vue?vue&type=template&id=195c03bc&scoped=true&"
import script from "./ReportOccurrenceQuality.vue?vue&type=script&lang=js&"
export * from "./ReportOccurrenceQuality.vue?vue&type=script&lang=js&"
import style0 from "./ReportOccurrenceQuality.vue?vue&type=style&index=0&id=195c03bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195c03bc",
  null
  
)

export default component.exports